import { object } from 'prop-types'
import { Accordion, ArrowDownIcon, Pagination, PulsingCircle } from 'shared/ui'
import React from 'react'
import { LeadsListEmpty } from 'homepage/presentation/components/LeadsListEmpty'
import {
  LeadsListWrapper,
  Step,
  StepWrapper,
} from 'homepage/presentation/components/Home.styles'
import { ProposalHeader } from 'shared/ui/ProposalsItems/ProposalHeader'
import { AccordionContent, AccordionItem } from 'shared/ui/Accordion'
import {
  AccordionHeaderStyled,
  ArrowIcon,
  ContainerIconWarranty,
} from 'homepage/presentation/components/LeadsList/styles'
import { ProposalColumn } from 'shared/ui/ProposalsItems/ProposalColumn'
import { Box, IconCoinsMoneyPlusAdd } from '@creditas-ui/react'
import { formatCpf, formatDate } from 'shared/helpers'
import { definePulsingVariantHomeFin } from 'homepage/application/leadListService'
import { ContainerDetails } from 'homepage/presentation/components/AccordionDetails'
import { ContentResumeDetailHomeFin } from 'homepage/presentation/components/AccordionDetails/ContentResumeDetail'
import {
  CardFeed,
  CardResumeFeedHomeFin,
} from 'homepage/presentation/components/CardFeed'
import { PRODUCTS } from 'domain/enums'
import { AgentIndicateEmpty } from 'homepage/presentation/components/AgentIndicateEmpty'

const propTypes = {
  leads: object.isRequired,
}

const LeadsHomeFinList = ({ leads, page, changePage, limit, hasFilter }) => {
  return (
    <>
      {leads?.indications && leads?.indications.length > 0 && (
        <>
          <LeadsListWrapper>
            <ProposalHeader
              testId="leads-homefin-proposals-head"
              headings={[
                {
                  id: 'warranty',
                  title: '',
                },
                {
                  id: 'name',
                  title: 'Nome',
                },
                {
                  id: 'cpf',
                  title: 'CPF',
                },
                {
                  id: 'step',
                  title: 'Etapa',
                },
                {
                  id: 'date',
                  title: 'Data de criação',
                },
              ]}
            />

            <div>
              <Accordion>
                {leads.indications.map(item => (
                  <AccordionItem
                    testId={`lead-${item.customerid}`}
                    key={item.customerid}
                  >
                    <AccordionHeaderStyled id={item.customerid}>
                      <ProposalColumn
                        testId={`lead-product-${item.customerid}`}
                        style={{ gridArea: 'warranty' }}
                      >
                        <ContainerIconWarranty className="warrantyIcon">
                          <IconCoinsMoneyPlusAdd color="#596B64" />
                        </ContainerIconWarranty>
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-fullname-${item.customerid}`}
                        style={{ gridArea: 'name' }}
                      >
                        {item.name}
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-cpf-${item.customerid}`}
                        style={{ gridArea: 'cpf' }}
                      >
                        {formatCpf(item.cpf)}
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-step-${item.customerid}`}
                        style={{ gridArea: 'step' }}
                      >
                        <StepWrapper>
                          <PulsingCircle
                            variant={definePulsingVariantHomeFin({
                              currentStep: item.stepName,
                            })}
                          />
                          <Step>{item.stepName}</Step>
                        </StepWrapper>
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-dateCreated-${item.customerid}`}
                        style={{ gridArea: 'date' }}
                      >
                        {formatDate(item.creationdate)}
                      </ProposalColumn>
                      <ArrowIcon>
                        <ArrowDownIcon />
                      </ArrowIcon>
                    </AccordionHeaderStyled>

                    <AccordionContent productType={PRODUCTS.HOME_FIN}>
                      <ContainerDetails>
                        <Box width="100%">
                          <ContentResumeDetailHomeFin
                            id={item.customerid}
                            lead={item}
                          />
                        </Box>
                        <CardFeed>
                          <CardResumeFeedHomeFin lead={item} />
                        </CardFeed>
                      </ContainerDetails>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </LeadsListWrapper>
          <Pagination
            testId="leads-pagination"
            currentPage={page}
            onChangePage={changePage}
            totalItems={leads?.total}
            limit={limit}
            totalVisibleItems={5}
          />
        </>
      )}
      {hasFilter && leads?.indications && leads.indications.length === 0 && (
        <LeadsListEmpty />
      )}
      {!hasFilter && leads?.indications && leads.indications.length === 0 && (
        <AgentIndicateEmpty />
      )}
      {!leads?.indications && <AgentIndicateEmpty />}
    </>
  )
}

LeadsHomeFinList.propTypes = propTypes

export { LeadsHomeFinList }
